import * as THREE from 'three';
import ControlPoint from './ControlPoint';
import LinkingPointObject from './LinkingPointObject';
import {
  ControlPointObjectType,
  EditType,
  LinkingPointObjectType,
  LoadType,
  SectionsObjetType,
} from '../types';
import { TextObject } from './TextObject';
import { addNotificationDispatch } from '../js';
import { EventUpdateControlPoint } from '../../helpers/events';

export interface BridgesType {
  start: ControlPointObjectType;
  end: ControlPointObjectType;
}
export class SectionsObject extends THREE.Group implements SectionsObjetType {
  private loadObject: LoadType;
  private editObject: EditType;
  static symbolsPoints: Array<string> = [];
  controlsPointsObjects: Array<ControlPoint> = [];
  controlPoints: Array<THREE.Vector3> = [
    new THREE.Vector3(-2, 0, -2),
    new THREE.Vector3(2, 0, -2),
    new THREE.Vector3(2, 0, 2),
    new THREE.Vector3(-2, 0, 2),
  ];
  bridges: Array<BridgesType> = [];
  rooms: Array<Array<number>> = [];

  constructor(loadObjet: LoadType, editObject: EditType) {
    super();
    SectionsObject.getSymbolsControlsPoints();
    this.name = 'section_object';
    this.loadObject = loadObjet;
    this.editObject = editObject;

    this.controlPoints.forEach(item => {
      item.setY(this.editObject.totalPointHeight);
    });
  }

  buildSector() {
    for (let i = 0; i < this.controlPoints.length; i++) {
      this.createControlPoint(this.controlPoints[i]);
    }
    this.createLinesBetweenPoints();
    addNotificationDispatch('Сектор успешно создан ', 'success');
  }
  createControlPoint(
    position: THREE.Vector3,
    sequenceNumber: number | null = null,
    isScale?: boolean
  ) {
    const circle = new ControlPoint();
    circle.position.copy(position);
    circle.textObject = this.addingSymbolPoint(position);
    if (sequenceNumber === null) {
      this.add(circle);
      this.controlsPointsObjects.push(circle);
    } else {
      this.children.splice(sequenceNumber, 0, circle);
      this.controlsPointsObjects.splice(sequenceNumber, 0, circle);
    }

    if (this.editObject.dragObject) {
      this.editObject.dragObject.addObjectMove(circle);
      circle.parent = this;
    }
    this.loadObject.domElementListeners?.addObjectsIntersected(circle);
    if (isScale) {
      circle.scale.copy(this.controlsPointsObjects[0].scale);
      circle.textObject.scale.copy(this.controlsPointsObjects[0].scale);
    }
  }
  updatePositionControlsPoints() {
    this.controlPoints = [];
    this.controlsPointsObjects.map(item => {
      this.controlPoints.push(item.position.clone());
    });
    this.getSidesParamsDispatch();
  }
  updateHeightControlPoints(): void {
    this.controlPoints.forEach((item, index) => {
      item.setY(this.editObject.totalPointHeight);
      this.controlsPointsObjects[index].position.copy(item);
      if (this.controlsPointsObjects[index].textObject) {
        this.controlsPointsObjects[index].textObject?.setPosition(item);
      }
    });
    this.removeLinkLinesObjects();
    this.createLinesBetweenPoints();
  }
  createLinesBetweenPoints() {
    for (let i = 0; i < this.controlsPointsObjects.length; i++) {
      this.controlsPointsObjects[i].numberInLine = i;
      let line;
      if (i < this.controlsPointsObjects.length - 1) {
        const circle = this.controlsPointsObjects[i] as ControlPoint;
        const circle1 = this.controlsPointsObjects[i + 1] as ControlPoint;
        line = new LinkingPointObject({
          startPoint: {
            position: circle.position.clone(),
            numberPoint: i,
            symbolPoint: circle.textObject?.text || '$',
          },
          endPoint: {
            position: circle1.position.clone(),
            numberPoint: i + 1,
            symbolPoint: circle1.textObject?.text || '$',
          },
        });
        circle.linkPointStart = {
          lineObject: line,
          linkPoint: 'startPoint',
        };
        circle1.linkPointEnd = {
          lineObject: line,
          linkPoint: 'endPoint',
        };
      } //
      else {
        const circle = this.controlsPointsObjects[i] as ControlPoint;
        const circle0 = this.controlsPointsObjects[0] as ControlPoint;
        line = new LinkingPointObject({
          startPoint: {
            position: circle.position.clone(),
            numberPoint: i,
            symbolPoint: circle.textObject?.text || '$',
          },
          endPoint: {
            position: circle0.position.clone(),
            numberPoint: 0,
            symbolPoint: circle0.textObject?.text || '$',
          },
        });
        circle.linkPointStart = {
          lineObject: line,
          linkPoint: 'startPoint',
        };
        circle0.linkPointEnd = {
          lineObject: line,
          linkPoint: 'endPoint',
        };
      }
      this.add(line);

      this.loadObject.domElementListeners?.addObjectsIntersected(line);
    }
    if (this.bridges.length > 0) {
      for (let i = 0; i < this.bridges.length; i++) {
        this.createBridgeLine(this.bridges[i].start, this.bridges[i].end);
      }
    }
    this.getSidesParamsDispatch();
    this.createRooms();
  }
  createBridgeLine(start: ControlPointObjectType, end: ControlPointObjectType): void {
    const circleStart = start;
    const circleEnd = end;
    const line = new LinkingPointObject({
      startPoint: {
        position: circleStart.position.clone(),
        numberPoint: circleStart.numberInLine,
        symbolPoint: circleStart.textObject?.text || '$',
      },
      endPoint: {
        position: circleEnd.position.clone(),
        numberPoint: circleEnd.numberInLine,
        symbolPoint: circleEnd.textObject?.text || '$',
      },
    });
    circleStart.linkPointBridge = {
      lineObject: line,
      linkPoint: 'startPoint',
    };
    circleEnd.linkPointBridge = {
      lineObject: line,
      linkPoint: 'endPoint',
    };
    this.add(line);
  }
  splitLineTwo(line: LinkingPointObjectType) {
    const pointStart = this.controlPoints[line.startPoint.numberPoint].clone();
    const pointEnd = this.controlPoints[line.endPoint.numberPoint].clone();
    const dir = pointEnd.clone().sub(pointStart).normalize();
    const distHalf = pointStart.distanceTo(pointEnd) / 2;

    const pointHalt = pointStart.clone().add(dir.clone().multiplyScalar(distHalf));

    this.removeLinkLinesObjects();
    this.controlPoints.splice(line.startPoint.numberPoint + 1, 0, pointHalt);
    this.createControlPoint(pointHalt, line.startPoint.numberPoint + 1, true);
    this.createLinesBetweenPoints();
  }
  addingSymbolPoint(position: THREE.Vector3) {
    const text = new TextObject(SectionsObject.symbolsPoints[0], 0.1);
    SectionsObject.symbolsPoints.shift();
    text.position.copy(position);
    text.setStartPosition();
    this.add(text);
    return text;
  }
  removeControlPoint(controlPoint: ControlPointObjectType) {
    if (this.controlsPointsObjects.length <= 4) {
      addNotificationDispatch(
        'Невозможно удалить эту точку. Секция должна содержать не менее 4-ех точек',
        'error'
      );
      return;
    }
    const index = this.controlsPointsObjects.findIndex(item => item.uuid === controlPoint.uuid);
    if (index !== -1) {
      const indexBridge = this.bridges.findIndex(
        item => item.start.uuid === controlPoint.uuid || item.end.uuid === controlPoint.uuid
      );
      if (indexBridge !== -1) {
        this.bridges[indexBridge].start.linkPointBridge = null;
        this.bridges[indexBridge].end.linkPointBridge = null;
        this.bridges.splice(indexBridge, 1);
      }

      this.removeLinkLinesObjects();
      this.loadObject.domElementListeners?.removeObjectsIntersected(controlPoint.uuid);
      if (this.editObject.dragObject) {
        this.editObject.dragObject.removeObjectMove(controlPoint.uuid);
      }

      this.controlsPointsObjects.splice(index, 1);
      this.controlPoints.splice(index, 1);
      if (controlPoint.textObject) {
        const currSymbol = controlPoint.textObject.text;
        SectionsObject.symbolsPoints.push(currSymbol);
        SectionsObject.symbolsPoints.sort();
        controlPoint.textObject.removeMesh();
      }
      controlPoint.removeMesh();
      this.createLinesBetweenPoints();
    }
  }
  removeSector() {
    SectionsObject.symbolsPoints.length = 0;
    SectionsObject.getSymbolsControlsPoints();
    this.controlsPointsObjects.length = 0;
    this.controlPoints.length = 0;
    this.bridges.length = 0;
    while (this.children.length > 0) {
      const findObj = this.children[0] as ControlPoint;

      this?.loadObject?.domElementListeners?.removeObjectsIntersected(findObj.uuid);
      this?.editObject?.dragObject?.removeObjectMove(findObj.uuid);

      findObj.removeMesh();
    }
    this.editObject.linesSection.length = 0;
    this.parent?.remove(this);
  }
  getAreaSector(): number {
    const contour: Array<THREE.Vector2> = this.controlPoints.map(item => {
      return new THREE.Vector2(item.x, item.z);
    });
    return THREE.ShapeUtils.area(contour) * this.editObject.scaleCoefficient ** 2;
  }
  updateDimensions() {
    this.children.forEach(item => {
      if (item.type === 'line_point') {
        const line = item as LinkingPointObjectType;
        if (line.dimensionObject) {
          line.dimensionObject.rebuildGroup(line.startPoint.position, line.endPoint.position);
        }
      }
    });
    this.getSidesParamsDispatch();
  }
  updateScaleControlObjects(sc: number) {
    if (this.controlsPointsObjects.length) {
      this.controlsPointsObjects.forEach(item => {
        item.scale.setX(sc);
        item.scale.setZ(sc);
        item.textObject?.scale.set(sc, 1, sc);
      });
    }
  }
  createRooms() {
    this.rooms = [];

    const startsPoints = this.controlsPointsObjects.filter(
      item => item?.linkPointBridge?.linkPoint === 'startPoint'
    );
    const lastObj = startsPoints[startsPoints.length - 1];
    if (lastObj && this.controlsPointsObjects[lastObj.numberInLine + 1]) {
      startsPoints.push(this.controlsPointsObjects[lastObj.numberInLine + 1]);
    } else {
      startsPoints.push(this.controlsPointsObjects[0]);
    }
    for (let i = 0; i < startsPoints.length; i++) {
      const res: number[] = getNextStartPoint(this, startsPoints[i].numberInLine);

      this.rooms.push(res);
    }

    // console.log(this.rooms);

    function getNextStartPoint(scope: SectionsObjetType, startPoint: number): number[] {
      const results = [];
      const startObj = scope.controlsPointsObjects[startPoint];
      let nextObj;
      if (startObj?.linkPointBridge) {
        const index = startObj.linkPointBridge.lineObject.endPoint.numberPoint;
        const endObj = scope.controlsPointsObjects[index];
        results.push(startObj.numberInLine, endObj.numberInLine);
        if (endObj?.linkPointStart) {
          const index1 = endObj.linkPointStart.lineObject.endPoint.numberPoint;
          nextObj = scope.controlsPointsObjects[index1];
          results.push(nextObj.numberInLine);
        }
      } else if (startObj?.linkPointStart) {
        const index = startObj.linkPointStart.lineObject.endPoint.numberPoint;
        nextObj = scope.controlsPointsObjects[index];
        results.push(startPoint, nextObj.numberInLine);
      }

      if (!nextObj) return [];
      let stopProcess = false;
      let number = 0;
      while (!stopProcess && number < 20) {
        if (nextObj.linkPointBridge && nextObj.linkPointBridge.linkPoint === 'endPoint') {
          const indexNext: number = nextObj.linkPointBridge.lineObject.startPoint.numberPoint;
          nextObj = scope.controlsPointsObjects[indexNext];
        } //
        else if (nextObj?.linkPointStart) {
          const indexNext: number = nextObj.linkPointStart.lineObject.endPoint.numberPoint;
          nextObj = scope.controlsPointsObjects[indexNext];
        }

        stopProcess = startPoint === nextObj.numberInLine;
        if (!stopProcess) {
          results.push(nextObj.numberInLine);
        }
        number++;
      }

      return results;
    }
  }
  deleteDrainFunnel() {
    this.editObject.removeDrainFunnel();
    this.editObject.removeSlopedSurface();
  }

  private removeLinkLinesObjects() {
    let findObj;
    while ((findObj = this.getObjectByName('line_point'))) {
      if (findObj) {
        this?.loadObject?.domElementListeners?.removeObjectsIntersected(findObj.uuid);
        (findObj as LinkingPointObjectType).removeMesh();
      }
    }
  }
  private getSidesParamsDispatch(): void {
    const vectorRight = new THREE.Vector3(1, 0, 0);

    const lines = this.children.filter(line => line.type === 'line_point');

    this.editObject.linesSection = lines.map(item => {
      const line = item as LinkingPointObjectType;
      const direct = line.endPoint.position.clone().sub(line.startPoint.position).normalize();

      const directN = direct.clone().negate();
      const y = vectorRight.clone().cross(direct).getComponent(1);
      const yEnd = vectorRight.clone().cross(directN).getComponent(1);
      const angle = vectorRight.angleTo(direct);
      const angleEnd = vectorRight.angleTo(directN);

      let someEnd = 1;
      if (yEnd < 0) {
        someEnd = -1;
      }

      let some = 1;
      if (y < 0) {
        some = -1;
      }
      return {
        length:
          line.startPoint.position.distanceTo(line.endPoint.position) *
          this.editObject.scaleCoefficient,
        nameStart: line.startPoint.symbolPoint,
        nameEnd: line.endPoint.symbolPoint,
        angleEnd: angleEnd * someEnd,
        angleStart: angle * some,
      };
    });
    document.dispatchEvent(new CustomEvent(EventUpdateControlPoint));
  }
  static getSymbolsControlsPoints = () => {
    for (let i = 65; i < 91; i++) {
      SectionsObject.symbolsPoints.push(String.fromCharCode(i));
    }
  };
}
